class WinkingDog extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    setInterval(() => {
      this.classList.toggle('ft-Footer_Dogs-wink', true)

      setTimeout(() => {
        this.classList.toggle('ft-Footer_Dogs-wink', false)
      }, 500)
    }, 5000)
  }
}

if (!customElements.get('winking-dog')) {
  customElements.define('winking-dog', WinkingDog)
}
